import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TPromoCodes } from "../../Types";
import { post } from "../axios-post";
import { TRewardBenefitType } from "../../TypesNEW";

export const apiCallGetAllPromocodes = async (
  limit: number
): Promise<{
  data: TPromoCodes;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TPromoCodes>(
    `auditor/getAllPromoCodes`,
    { limit }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};

export const apiCallUpdatePromoCode = async ({
  promoCode,
  promoCodeId,
  isActive
}: {
  promoCode: string;
  promoCodeId: number;
  isActive: number;
}): Promise<{
  data: { promoCodeUpdated: boolean };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    promoCodeUpdated: boolean;
  }>(`auditor/updatePromoCode`, {
    promo_code: promoCode,
    promo_code_id: promoCodeId,
    is_active: isActive
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { promoCodeUpdated: false },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { promoCodeUpdated: false },
      status: "ERROR",
      code: "ERROR"
    };
  }
};

export const apiCallgetPromoCodeUsageHistory = async ({
  promoCode
}: {
  promoCode: string;
}): Promise<{
  data: {
    user_id: number;
    isUserRewarded: number;
    rewardType: TRewardBenefitType;
    rewardAmountInHours: number;
    reason: string;
    created_on: string;
  }[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<
    {
      user_id: number;
      isUserRewarded: number;
      rewardType: TRewardBenefitType;
      rewardAmountInHours: number;
      reason: string;
      created_on: string;
    }[]
  >(`auditor/getPromoCodeUsageHistory`, {
    promo_code: promoCode
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
